import { isMailableAddress, isUSCountry, isValidUSZipCode } from "@shared/v2/utils";

/**
 * Extracts address attributes from a person's included data
 * @param {Object} person - The person object containing included addresses
 * @returns {Array} Array of address objects with id and attributes
 */
export const getAddressAttributes = (person) =>
  (person?.included || [])
    .filter((a) => a.type === "address" && a.id !== null)
    .map((address) => ({ ...address.attributes, id: address.id }));

export const getAddressSortPriority = (address) => {
  const isStandardized = address.standardized === "standardized";
  const isMailable = isMailableAddress(address);
  if (isMailable && isStandardized) return 0; // Verified and valid first
  if (isMailable) return 1; // Unverified but valid second
  return 2; // Invalid (including non-US) last
};

export const getInvalidReason = (address) => {
  if (!address?.street_address?.trim()) return "Missing street address";
  if (!address?.city?.trim()) return "Missing city";
  if (!address?.locality?.trim()) return "Missing state";
  if (!isUSCountry(address?.country)) return "Non-US addresses are not supported";
  if (!address?.postal_code?.trim()) return "Missing postal code";
  if (!isValidUSZipCode(address?.postal_code)) return "Invalid ZIP code format";
  return null;
};
